/// <amd-module name="TFS/Admin/Common/RestClient/Invitation" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   vssf\client\webapi\httpclients\clientgeneratorconfigs\invitation.genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Invitation from "../Contracts/Invitation";

export interface IInvitationRestClient extends IVssRestClient {
    /**
     * Send Account Invitation to a user
     * 
     * @param invitationData - optional Invitation Data
     * @param userId - IdentityId of the user
     */
    sendInvitation(invitationData: Invitation.InvitationData, userId: string): Promise<void>;
    /**
     * Send invitation to a batch of users Currently only support less than 1000 users
     * 
     * @param invitationData - Invitation Data
     */
    sendInvitations(invitationData: Invitation.InvitationData): Promise<Invitation.SendInvitationsResponse>;
}

class InvitationRestClient extends RestClientBase implements IInvitationRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Send Account Invitation to a user
     * 
     * @param invitationData - optional Invitation Data
     * @param userId - IdentityId of the user
     */
    public async sendInvitation(
        invitationData: Invitation.InvitationData,
        userId: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "5.1-preview.1",
            method: "PUT",
            routeTemplate: "_apis/Invitations/{userId}",
            routeValues: {
                userId: userId
            },
            body: invitationData
        });
    }

    /**
     * Send invitation to a batch of users Currently only support less than 1000 users
     * 
     * @param invitationData - Invitation Data
     */
    public async sendInvitations(
        invitationData: Invitation.InvitationData
        ): Promise<Invitation.SendInvitationsResponse> {

        return this.beginRequest<Invitation.SendInvitationsResponse>({
            apiVersion: "5.1-preview.1",
            method: "POST",
            routeTemplate: "_apis/Invitations/{userId}",
            body: invitationData
        });
    }

}

export const InvitationClientName = "IInvitationRestClient";

export function getInvitationClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IInvitationRestClient {
    return pageContext.getRestClient<IInvitationRestClient>(InvitationClientName, options);
}

RestClients.add(InvitationClientName, { 
    factory: InvitationRestClient,
    options: {
        serviceInstanceType: "951917ac-a960-4999-8464-e3f0aa25b381"
    }
});
